import { defineMessages } from "../define";

/** Texts shared by every area: generic actions and states, statuses, counts, photo-quality reasons. */
export default defineMessages({
  en: {
    "common.loading": "Loading…",
    "common.noPeriodData": "No data for the selected period",
    "common.score": "Score",
    "common.noData": "No data",
    "common.images": "images",
    "common.language": "Language",
    "common.fullscreen": "Fullscreen",
    "common.exitFullscreen": "Exit fullscreen",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.done": "Done",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.create": "Create",
    "common.add": "Add",
    "common.remove": "Remove",
    "common.back": "Back",
    "common.next": "Next",
    "common.previous": "Previous",
    "common.search": "Search",
    "common.clear": "Clear",
    "common.clearAll": "Clear all",
    "common.filters": "Filters",
    "common.columns": "Columns",
    "common.actions": "Actions",
    "common.copy": "Copy",
    "common.copied": "{what} copied",
    "common.copyFailed": "Could not copy: {what}",
    "common.open": "Open",
    "common.show": "Show",
    "common.hide": "Hide",
    "common.all": "All",
    "common.none": "None",
    "common.yes": "Yes",
    "common.no": "No",
    "common.notAvailable": "N/A",
    "common.unknown": "Unknown",
    "common.details": "Details",
    "common.status": "Status",
    "common.name": "Name",
    "common.branch": "Branch",
    "common.branches": "Branches",
    "common.pizza": "Pizza",
    "common.pizzas": "Pizzas",
    "common.order": "Order",
    "common.orders": "Orders",
    "common.today": "Today",
    "common.yesterday": "Yesterday",
    "common.anyTime": "Any time",
    "common.last7Days": "Last 7 days",
    "common.last30Days": "Last 30 days",
    "common.from": "From {date}",
    "common.until": "Until {date}",
    "common.perPage": "Per page",
    "common.autoPageSize": "Auto ({count})",
    "common.autoPageSizeOption": "Auto (fit the window)",
    "common.firstPage": "First page",
    "common.previousPage": "Previous page",
    "common.nextPage": "Next page",
    "common.lastPage": "Last page",
    "common.page": "Page {page} of {pages}",
    "common.error": "Something went wrong",
    "common.noResults": "No results",
    "common.clearDateFilter": "Clear the date filter",
    "date.pickDate": "Pick a date",
    "status.ok": "OK",
    "status.nok": "NOK",
    "status.warning": "Warning",
    "status.na": "N/A",
    "status.notEvaluated": "Not evaluated",
    "status.noPizza": "No pizza",
    "status.invalidPhoto": "Invalid photo",
    "status.invalidShort": "Invalid",
    "count.pizzas.one": "{count} pizza",
    "count.pizzas.few": "{count} pizzas",
    "count.pizzas.other": "{count} pizzas",
    "count.orders.one": "{count} order",
    "count.orders.few": "{count} orders",
    "count.orders.other": "{count} orders",
    "count.items.one": "{count} item",
    "count.items.few": "{count} items",
    "count.items.other": "{count} items",
    "count.branches.one": "{count} branch",
    "count.branches.few": "{count} branches",
    "count.branches.other": "{count} branches",
    "photoReason.pizza_blurred": "Blurred pizza",
    "photoReason.obstacle_in_pizza_detected": "Obstacle over the pizza",
    "photoReason.pizza_visibility_below_threshold": "Pizza not fully visible",
    "photoReason.blurry": "Blurry",
    "photoReason.too_dark": "Too dark",
    "photoReason.too_bright": "Too bright",
    "photoReason.pizza_not_found": "Pizza not found",
    "photoReason.pizza_cut_off": "Pizza cut off",
    "photoReason.low_confidence": "Low confidence",
    "photoReason.occluded": "Occluded",
    "photoReason.background_cluttered": "Cluttered background",
    "photoReason.motion_blur": "Motion blur",
    "photoReason.out_of_focus": "Out of focus",
    "photoReason.underexposed": "Underexposed",
    "photoReason.overexposed": "Overexposed",
    "photoReason.reflection": "Reflection",
    "photoReason.shadow": "Shadow",
    "photoReason.poor_angle": "Poor angle",
    "photoReason.too_far": "Too far",
    "photoReason.too_close": "Too close",
  },
  cs: {
    "common.loading": "Načítání…",
    "common.noPeriodData": "Žádná data pro vybrané období",
    "common.score": "Skóre",
    "common.noData": "Bez dat",
    "common.images": "snímků",
    "common.language": "Jazyk",
    "common.fullscreen": "Celá obrazovka",
    "common.exitFullscreen": "Ukončit celou obrazovku",
    "common.save": "Uložit",
    "common.cancel": "Zrušit",
    "common.close": "Zavřít",
    "common.done": "Hotovo",
    "common.delete": "Smazat",
    "common.edit": "Upravit",
    "common.create": "Vytvořit",
    "common.add": "Přidat",
    "common.remove": "Odebrat",
    "common.back": "Zpět",
    "common.next": "Další",
    "common.previous": "Předchozí",
    "common.search": "Hledat",
    "common.clear": "Vymazat",
    "common.clearAll": "Vymazat vše",
    "common.filters": "Filtry",
    "common.columns": "Sloupce",
    "common.actions": "Akce",
    "common.copy": "Kopírovat",
    "common.copied": "Zkopírováno: {what}",
    "common.copyFailed": "Nepodařilo se zkopírovat: {what}",
    "common.open": "Otevřít",
    "common.show": "Zobrazit",
    "common.hide": "Skrýt",
    "common.all": "Vše",
    "common.none": "Žádné",
    "common.yes": "Ano",
    "common.no": "Ne",
    "common.notAvailable": "–",
    "common.unknown": "Neznámé",
    "common.details": "Podrobnosti",
    "common.status": "Stav",
    "common.name": "Název",
    "common.branch": "Pobočka",
    "common.branches": "Pobočky",
    "common.pizza": "Pizza",
    "common.pizzas": "Pizzy",
    "common.order": "Objednávka",
    "common.orders": "Objednávky",
    "common.today": "Dnes",
    "common.yesterday": "Včera",
    "common.anyTime": "Kdykoli",
    "common.last7Days": "Posledních 7 dní",
    "common.last30Days": "Posledních 30 dní",
    "common.from": "Od {date}",
    "common.until": "Do {date}",
    "common.perPage": "Na stránku",
    "common.autoPageSize": "Auto ({count})",
    "common.autoPageSizeOption": "Auto (podle okna)",
    "common.firstPage": "První stránka",
    "common.previousPage": "Předchozí stránka",
    "common.nextPage": "Další stránka",
    "common.lastPage": "Poslední stránka",
    "common.page": "Stránka {page} z {pages}",
    "common.error": "Něco se pokazilo",
    "common.noResults": "Žádné výsledky",
    "common.clearDateFilter": "Zrušit filtr data",
    "date.pickDate": "Vyberte datum",
    "status.ok": "OK",
    "status.nok": "NEOK",
    "status.warning": "Varování",
    "status.na": "–",
    "status.notEvaluated": "Nevyhodnoceno",
    "status.noPizza": "Bez pizzy",
    "status.invalidPhoto": "Neplatná fotka",
    "status.invalidShort": "Neplatná",
    "count.pizzas.one": "{count} pizza",
    "count.pizzas.few": "{count} pizzy",
    "count.pizzas.other": "{count} pizz",
    "count.orders.one": "{count} objednávka",
    "count.orders.few": "{count} objednávky",
    "count.orders.other": "{count} objednávek",
    "count.items.one": "{count} položka",
    "count.items.few": "{count} položky",
    "count.items.other": "{count} položek",
    "count.branches.one": "{count} pobočka",
    "count.branches.few": "{count} pobočky",
    "count.branches.other": "{count} poboček",
    "photoReason.pizza_blurred": "Rozmazaná pizza",
    "photoReason.obstacle_in_pizza_detected": "Překážka na pizze",
    "photoReason.pizza_visibility_below_threshold": "Pizza není celá vidět",
    "photoReason.blurry": "Rozmazané",
    "photoReason.too_dark": "Příliš tmavé",
    "photoReason.too_bright": "Příliš světlé",
    "photoReason.pizza_not_found": "Pizza nenalezena",
    "photoReason.pizza_cut_off": "Pizza je oříznutá",
    "photoReason.low_confidence": "Nízká jistota",
    "photoReason.occluded": "Zakryto",
    "photoReason.background_cluttered": "Rušivé pozadí",
    "photoReason.motion_blur": "Rozmazání pohybem",
    "photoReason.out_of_focus": "Rozostřené",
    "photoReason.underexposed": "Podexponované",
    "photoReason.overexposed": "Přeexponované",
    "photoReason.reflection": "Odlesk",
    "photoReason.shadow": "Stín",
    "photoReason.poor_angle": "Špatný úhel",
    "photoReason.too_far": "Příliš daleko",
    "photoReason.too_close": "Příliš blízko",
  },
});
